import React from 'react';
import PropTypes from 'prop-types';
import './AddressSearchLoading.scss';
import loader from '../../../assets/loading.gif';

const AddressSearchLoading = (props) => {
  if (!props.showLoading) {
    return null;
  }
  return (
    <span className="address-search-loading input-group-addon" aria-hidden="true">
      <img className="address-search-loading-image" src={loader} height="20" alt="Loading..." role="presentation" />
    </span>
  );
};

AddressSearchLoading.propTypes = {
  showLoading: PropTypes.bool
};

export default AddressSearchLoading;



/** WEBPACK FOOTER **
 ** ./src/components/AddressSearch/AddressSearchLoading/AddressSearchLoading.js
 **/